import { BUTTON_TYPE } from "components/AuditButton";

export class ModalService {
  constructor() {
    this.modal = undefined;
    this.close = this.close.bind(this);
  }

  // Internal methods
  static _okCallback(okCallback) {
    if (okCallback && typeof okCallback === "function") okCallback();
    this.close("ok");
  }

  static _cancelCallback(cancelCallback) {
    if (cancelCallback && typeof cancelCallback === "function")
      cancelCallback();
    this.close("fail");
  }

  static _promiseResolver(resolve, reject) {
    document.addEventListener("close", function handler(e) {
      if (e.detail.resolved) {
        resolve(e.detail && e.detail.data);
      } else {
        reject(e.detail && e.detail.data);
      }
      document.removeEventListener("close", handler);
    });
  }

  _register(modal) {
    this.modal = modal;
  }

  _unregister() {
    this.modal = undefined;
  }

  // Public methods
  close(reason, data) {
    this.modal.close();

    let closeEvent = new CustomEvent("close", {
      detail: {
        resolved: reason === "ok" ? true : false,
        data
      }
    });
    document.dispatchEvent(closeEvent);
  }

  show(opts) {
    let promise = new Promise(ModalService._promiseResolver);

    this.modal.show(opts);

    return promise;
  }

  alert(titleLabelId, bodyLabelId, okCallback, okLabelId, okButtonType, size) {
    let opts = {
      titleLabelId,
      bodyLabelId,
      buttons: [
        {
          type: !okButtonType ? BUTTON_TYPE.PRIMARY : okButtonType,
          callback: ModalService._okCallback.bind(this, okCallback),
          labelId: okLabelId || "common.ok"
        }
      ],
      size: size
    };

    return this.show(opts);
  }

  prompt(titleLabelId, bodyLabelId) {
    let opts = {
      titleLabelId,
      bodyLabelId
    };
    return this.show(opts);
  }

  confirm(
    titleLabelId,
    bodyLabelId,
    okCallback,
    cancelCallback,
    okLabelId,
    cancelLabelId
  ) {
    let opts = {
      titleLabelId,
      bodyLabelId,
      buttons: [
        {
          marginRight: true,
          type: BUTTON_TYPE.SECONDARY,
          callback: ModalService._cancelCallback.bind(this, cancelCallback),
          labelId: cancelLabelId || "common.cancel"
        },
        {
          marginRight: false,
          type: BUTTON_TYPE.PRIMARY,
          callback: ModalService._okCallback.bind(this, okCallback),
          labelId: okLabelId || "common.yes"
        }
      ]
    };

    return this.show(opts);
  }
}

const modalService = new ModalService();
export { modalService };
